import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import UpdateForm from './UpdateForm';

interface RouteParams {
  id: string;
}

interface CurrentUser {
  id: number;
}

interface UpdateEmployeeProps extends RouteComponentProps<RouteParams> {
  match: {
    params: RouteParams;
  };
  user: CurrentUser;
}

const UpdateEmployee: React.FC<UpdateEmployeeProps> = ({ match, user }) => {
  return React.createElement(UpdateForm, { empId: Number(match.params.id), user });
};

export default UpdateEmployee;
